import { Box, Container, VStack } from '@bpba/ui-components';
import React, { useState } from 'react';
import styled from 'styled-components';
import { ErrorBoundary } from '../ErrorBoundary';
import { APP_BG, APP_BG_MOBILE, APP_TITLE } from './Constantes';
import { Title } from './Title';
import { ContainerContent } from './ContainerContent';
import { ContainerMain } from './ContainerMain';
import { LayoutProps } from '../../types/LayoutProps';
import { Queries } from '../../rest/Queries';
import { ApolloError, useQuery } from '@apollo/client';
import { statusQuery } from '../../rest/queries/status.get';
import { Status } from '../../rest/models/Status';

export const StatusContext = React.createContext<Status | null>(null);

export const Layout = (props: LayoutProps) => {
  const [appStatus, setStatus] = useState<Status | null>(null);

  useQuery<Queries>(statusQuery, {
    onCompleted: handleResponse,
    onError: handleError,
  });

  function handleResponse(query: Queries) {
    const status: Status = {
      availableService: query.status.availableService,
      message: query.status.message,
      messageHome: query.status.messageHome,
    };
    setStatus(status);
  }

  function handleError(error: ApolloError) {
    const forceEnable: Status = { availableService: true, message: '', messageHome: '' };
    setStatus(forceEnable);
  }

  return (
    <StatusContext.Provider value={appStatus}>
      <BgContainer minHeight={['auto', '100vh']}>
        <Container marginTop={'0px!important'}>
          <VStack>
            <ContainerMain>
              <Title title={APP_TITLE} />
              <ErrorBoundary>
                <ContainerContent>{props.children}</ContainerContent>
              </ErrorBoundary>
            </ContainerMain>
          </VStack>
        </Container>
      </BgContainer>
    </StatusContext.Provider>
  );
};

export const BgContainer = styled(Box)`
  background-image: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.6)), url(${APP_BG});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;

  /* 💻 Desktop: cinematic */
  @media (min-width: 769px) {
    background-position: center center;
  }

  /* 📱 Mobile: sharp & punchy */
  @media (max-width: 768px) {
    background-image: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.6)), url(${APP_BG_MOBILE});

    background-attachment: scroll;
    background-position: center top;
  }
`;
